export default __webpack_public_path__ + "static/media/Frame 185.74125181.svg";